import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/departments/new/loading';

export const Route = createFileRoute('/_private/settings/departments/new')({
  component: Loading,
});
